import { TLang } from 'src/constants/langs'
import { LocalizedText } from 'src/types/common/localized'

export function getLocalizedText<T extends boolean = false>(
    lang: TLang,
    texts: Record<TLang, LocalizedText<T>>
): LocalizedText<T> {
    return texts[lang] ?? texts.en
}
